import React from 'react';
import { FileText, Download } from 'lucide-react';

interface ResourceCardProps {
  title: string;
  description: string;
  type: string;
  formats: string[];
  onDownload: () => void;
}

const ResourceCard: React.FC<ResourceCardProps> = ({
  title,
  description,
  type,
  formats,
  onDownload
}) => {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="p-6">
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <FileText className="h-8 w-8 text-blue-600" />
          </div>
          <div className="flex-1">
            <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
            <p className="text-gray-600 mb-4">{description}</p>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded-full">
                  {type}
                </span>
                <div className="text-sm text-gray-500">
                  Available formats: {formats.join(', ').toUpperCase()}
                </div>
              </div>
              <button
                onClick={onDownload}
                className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
              >
                <Download className="h-4 w-4 mr-2" />
                Download
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourceCard;